import React, { forwardRef } from 'react';
import { Button } from '@mui/material';
import { GridApiPremium } from '@mui/x-data-grid-premium/models/gridApiPremium';
import { DataGrid } from '../DataGrid/DataGrid';
import { GridColDef, GridRenderCellParams } from '@mui/x-data-grid';
import { DateCell } from '../DataGrid/Cells/DateCell';
import { StatusCell } from '../DataGrid/Cells/StatusCell';
import { HubsNames, useSignalRHubStore } from '../../stores/useSignalR';
import { ProfileSignalRQueryOperation } from '../../types/api/profile';

interface DataGridProps {
  data?: any[];
  loading?: boolean;
}

export const MPAStatusDataGrid = forwardRef<GridApiPremium | null, DataGridProps>(
  ({ data = [], loading }, ref) => {
    const invokeMethod = useSignalRHubStore((state) => state.invokeMethod);
    const hubs = useSignalRHubStore((state) => state.hubs);

    const resubmitMPA = () => {
      const singleHub = hubs[HubsNames.mpaStatusSubmit];
      invokeMethod(
        HubsNames.mpaStatusSubmit,
        ProfileSignalRQueryOperation.SubmitSummary,
        singleHub.streamArgs,
      );
    };

    const MPAStatusColumns: GridColDef[] = [
      {
        field: 'recipient',
        headerName: 'Recipient',
        width: 120,
      },
      {
        field: 'timestamp.date',
        headerName: 'Time',
        flex: 1,
        renderCell: (data: GridRenderCellParams) => {
          return <DateCell dateValue={data.row?.timestamp?.date} />;
        },
      },
      {
        field: 'status',
        headerName: 'Status',
        width: 100,
        renderCell: (data: GridRenderCellParams) => {
          return <StatusCell statusCode={data.row.status} />;
        },
      },
      {
        field: 'response',
        headerName: 'Response',
        flex: 2,
        renderCell: (data: GridRenderCellParams) => {
          if (data.row.status === 1) return '---';
          return data.row.response;
        },
      },
      {
        field: 'resend',
        headerName: '',
        width: 100,
        renderCell: (data: GridRenderCellParams) => {
          const idx = data.api.getRowIndexRelativeToVisibleRows(data.id);
          if (idx === 0 && data.row.status === 3)
            return (
              <Button variant="text" onClick={() => resubmitMPA()}>
                Resend
              </Button>
            );
          return <div />;
        },
      },
    ];

    return (
      <DataGrid
        ref={ref}
        loading={loading}
        rows={data}
        columns={MPAStatusColumns}
        getRowId={(row) => row.id}
      />
    );
  },
);
